import type { Account } from "@shared/types/connection"
import { onSnapshot, query } from "firebase/firestore"
import { useEffect, useState } from "react"

import { accountsRef } from "../firestore/db"
import { useAuth } from "./useAuth"

export function useAccounts(connectionId: string | null) {
  const { user } = useAuth()
  const [accounts, setAccounts] = useState<Account[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!user || !connectionId) {
      setAccounts([])
      setLoading(false)
      return
    }

    const unsubscribe = onSnapshot(
      query(accountsRef(user.uid, connectionId)),
      (snapshot) => {
        setAccounts(snapshot.docs.map((doc) => doc.data()))
        setLoading(false)
      },
      (err) => {
        console.error("useAccounts:", err)
        setLoading(false)
      },
    )

    return unsubscribe
  }, [user, connectionId])

  return { accounts, loading }
}
